<template>
    <div class="box">
        <div class="operation">
            <el-form ref="form" :model="form" label-width="80px" class="form" :inline="true">
                <el-form-item label="手机号" label-position="right" class="mt">
                    <el-input v-model="form.mobile" size="small" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
            </el-form>
            <div class="mt">
                <el-button type="primary" class="btn" @click="queryFunc" icon="el-icon-search">查询</el-button>
                <el-button class="btn" @click="clearFunc" icon="el-icon-delete">重置</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="tabBox">
            <el-table v-loading="loading" ref="selections" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange"
                style="width: 100%" border element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <el-table-column type="selection" width="55" />
                <el-table-column prop="mobile" label="手机号" />
                <el-table-column prop="openId" label="微信openId" />
                <el-table-column prop="createTime" label="注册时间" />
                <el-table-column prop="state" label="状态">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.state" :active-value="0" :inactive-value="1" @change="updateState(scope.row)" />
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
                :total="total" class="pagination">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import WifiApi from '@/api/wifi.js'
export default {
    data() {
        return {
            form: {
                mobile: ''
            },
            tableData: [],
            loading: true,
            dialogFormVisible: false,
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            selections: []
        }
    },
    methods: {
        toggleSelection() {
            this.$refs.selections.clearSelection();
        },
        getDialogFormVisible(flag) {
            this.dialogFormVisible = flag
        },
        handleSelectionChange(val) {
            this.selections = val;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getList();
        },
        // 渲染列表
        getList() {
            this.loading = true;
            const params = {
                mobile: this.form.mobile,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            }
            WifiApi.userList({ ...params }).then(res => {
                this.tableData = res.data.records
                this.total = res.data.total
                this.loading = false;
            }).catch(e => {
                this.loading = false;
            })
        },
        updateState(row) {
            WifiApi.changeUserState({
                id: row.id,
                state: row.state
            }).then(res => {
                if(res.code !== 1 || res.errCode !== 200) {
                    row.state = row.state === 0 ? 1 : 0
                }
            })
        },
        // 查询按钮
        queryFunc() {
            this.pageIndex = 1
            this.getList();
        },
        clearFunc() {
            this.pageIndex = 1
            this.form.mobile = ''
            this.getList();
        }
    },
    mounted() {
        this.getList();
    }
}
</script>

<style scoped>
.mt {
    margin-top: 20px
}

.tabBox {
    margin: 40px 0;
}

.box {
    padding: 10px;
}



.form {
    margin-right: 20px;
}

.btn {
    margin-left: 15px;
    display: inline-block
}

.el-form-item {
    margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/user/index.vue